import {
  RELATIVES_API_URL,
  STORAGE_API_URL
} from "../../../shared/constants/api";

export const FILE_GET_RIGHTS_URL = `${STORAGE_API_URL}/get_rights`;
export const FILE_DELETE_URL = `${RELATIVES_API_URL}/v2/file/delete`;
export const FILE_UPLOAD_URL = `${RELATIVES_API_URL}/v3/customer_upload_foto`;
export const FILE_CONNECT_URL = `${RELATIVES_API_URL}/v1/file/:fileHash/connection`;
